import * as React from 'react';

const ChevronRight = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={16}
    fill="none"
    {...props}
  >
    <path
      d="M0 1.333 1.429 0 10 8l-8.571 8L0 14.667 7.143 8 0 1.333Z"
      fill="#78879A"
    />
  </svg>
);

export default ChevronRight;
